import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';
import { EnumErrorStates, ErrorObject } from '@inmoment/the-kitchen';

import { FieldStatisticsPayload } from 'app/providers/field-statistics.service';
import { CalculationRequest } from 'app/providers/storage-api/predictive.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { generalNameValidator } from 'app/utils/customValidators';
import { ProjectCollection } from './../../../models/project-collection.model';
import { DriverAnalysisStep } from '../driver-analysis-dialog.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-analysis-name-step',
  templateUrl: './analysis-name-step.component.html',
  styleUrls: ['./analysis-name-step.component.scss'],
  standalone: false,
})
export class AnalysisNameStepComponent implements DriverAnalysisStep, OnInit, OnChanges {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() data: Partial<CalculationRequest>;
  @Input() collection: ProjectCollection;
  @Input() fieldStatisticsPayload: FieldStatisticsPayload;

  @Output() onValidityChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  isLoading = false;
  analysisNameStatus: ErrorObject = { state: EnumErrorStates.SUCCESS };
  existingAnalysisNames = [];

  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.existingAnalysisNames = this.collection.driverAnalyses?.map((a) => a.displayName);
    this.onValidateAnalysisName();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.collection?.currentValue) {
      this.existingAnalysisNames = this.collection.driverAnalyses?.map((a) => a.displayName);
      this.onValidateAnalysisName();
    }
  }

  onValidateAnalysisName() {
    this.data.displayName = this.data.displayName.trim();

    generalNameValidator(
      this.data.displayName,
      this.analysisNameStatus,
      this.translocoService.translate('driver-analysis-dialog.analysis-name-step.kda'),
      64,
      true,
      this.existingAnalysisNames,
      false
    );

    this.onValidityChange.emit(this.analysisNameStatus.state !== EnumErrorStates.ERROR);
  }
}
